import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TEU_LOGO_SVG_BLUE } from '../../assets/constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subheader',
  standalone: true,
  imports: [CommonModule],

  templateUrl: './subheader.component.html',
  styleUrl: './subheader.component.css'
})
export class SubheaderComponent {
  @Input() circleNumber: number = 1; // Número del círculo
  @Input() backWindow: string = '';
  @Output() backClick = new EventEmitter<void>(); // Evento para el botón de atrás

  teuLogo: SafeHtml;

  constructor(private sanitizer: DomSanitizer, private router: Router) {
    this.teuLogo = this.sanitizer.bypassSecurityTrustHtml(TEU_LOGO_SVG_BLUE);

  }

  goBack() {
    this.backClick.emit();
  }

}
